import isString from 'lodash-es/isString';

import { useBrands, useDefaultBrand } from '../../contexts/SiteContext';

import { ReactComponent as Dehors } from '../../assets/img/brands/dehors_normalized.svg';
import { ReactComponent as Mollo } from '../../assets/img/brands/mollo_normalized.svg';
import { ReactComponent as PeriodeLibre } from '../../assets/img/brands/periodelibre_normalized.svg';
import { ReactComponent as Quatre95 } from '../../assets/img/brands/quatre95_normalized.svg';
import urbania from '../../assets/img/brands/urbania_normalized.png';

const logos = {
    urbania,
    france: urbania,
    dehors: Dehors,
    quatre95: Quatre95,
    mollo: Mollo,
    periodelibre: PeriodeLibre,
};

interface BrandLogoNormalizedProps {
    brand?: string | null;
    className?: string | null;
}

function BrandLogoNormalized({ brand = null, className = null }: BrandLogoNormalizedProps) {
    const defaultBrand = useDefaultBrand();

    const brands = useBrands();
    const { handle: brandHandle = null, label = null } =
        brands.find(({ handle }: { handle: string }) => handle === brand) || defaultBrand;

    const LogoComponent = logos[brandHandle as keyof typeof logos] || null;
    if (LogoComponent === null) {
        return null;
    }

    return isString(LogoComponent) ? (
        <img
            src={LogoComponent}
            className={className || undefined}
            alt={label || 'Logo'}
            title={label || 'Logo'}
        />
    ) : (
        <LogoComponent
            fill="currentColor"
            className={className || undefined}
            alt={label || 'Logo'}
            title={label || 'Logo'}
        />
    );
}

export default BrandLogoNormalized;
